<template>
    <sui-modal
            v-model="showModalDialog"
            style="z-index: 21000;"
            :closable="false"
    >
        <sui-modal-header>Загрузка снимка</sui-modal-header>
        <sui-modal-content>

            <div style="display: flex;align-items: center;height: 50px">
                <vue-upload-component
                        class="ui large blue button"
                        extensions="jpg,jpeg,png,tif"
                        accept="*/*"
                        :multiple="false"
                        :custom-action="uploadFile"
                        v-model="files"
                        ref="upload">
                    <i class="plus icon"></i>
                    Выбрать снимок
                </vue-upload-component>
                <div v-for="file in files" style="display: flex;align-items: center">
                    <h4 style="padding-left: 10px;padding-right:30px;margin: 0">
                        {{file.name}} ({{formatSize(file.size)}})
                    </h4>

                    <v-progress-circular
                            v-if="file.active"
                            indeterminate
                            :size="30"
                            color="blue darken-2"
                    />
                </div>
            </div>
        </sui-modal-content>
        <sui-modal-actions>
            <v-btn round color="blue darken-2" dark
                   v-if="files.length&&(!$refs.upload || !$refs.upload.active)"
                   @click="onStartUploadButtonClick">
                загрузить
            </v-btn>
            <v-btn round flat
                   @click="onCancelButtonClick">
                отмена
            </v-btn>
        </sui-modal-actions>
    </sui-modal>
</template>

<script>
    import Vue from 'vue'
    import filesize from 'filesize'

    import VueUploadComponent from 'vue-upload-component'

    export default {
        props: {
            show: {
                type: Boolean,
                default: false
            },
            uploadURL: {
                type: String,
                required: true
            },
            idToken: {
                type: String,
                default: null
            },
            aoiId: {
                type: String,
                default: null
            }
        },
        data() {
            return {
                showModalDialog: this.show,
                files: []
            }
        },
        computed: {
            imageUploaded() {
                return !!(this.files.length && this.files.every(({success}) => success));
            }
        },
        methods: {
            onStartUploadButtonClick() {
                this.$refs.upload.active = true
            },
            onCancelButtonClick() {
                this.$refs.upload.active = false;
                this.showModalDialog = false
            },
            formatSize(size) {
                return filesize(size);
            },
            uploadFile({file}) {
                const formData = new FormData();
                formData.append('file', file);

                return this.$axios.post(this.uploadURL,
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            'ID-TOKEN': this.idToken
                        },
                        params: {
                            aoiId: this.aoiId
                        }
                    }
                )
            }
        },

        components: {
            VueUploadComponent
        },

        watch: {
            show(newVal) {
                this.showModalDialog = newVal;
                if (newVal)
                    this.files = [];
            },
            showModalDialog(newVal) {
                this.$emit('update:show', newVal);
            },
            imageUploaded(newVal) {
                if (newVal)
                    this.showModalDialog = false;
            }
        }

    }
</script>

<style>
    .file-uploads.file-uploads-html5 label {
        cursor: pointer;
    }
</style>
